<template>
  <div class="ip-location">
    <h1>
      IP: {{ipAddress}}
    </h1>
    <h1>
      定位: {{location}}
    </h1>
    <h1>
      请求响应: {{responseStr}}
    </h1>
  </div>
</template>

<script>
import { apiListPC } from "@/api";
import ajax from "@/api/ajax";

export default {
    name: "ipLocation",
    async mounted() {
        this.getIpLocation();
    },
    data() {
        return {
            ipAddress: "",
            location: "",
            responseStr: "",
        };
    },
    methods: {
        getIpLocation() {
            ajax(apiListPC.getIpLocation, {}, "GET", this).then((res) => {
                this.ipAddress = res.ip;
                this.location = res.province + res.city;
                this.responseStr = res.remark;
            });
        },
    },
};
</script>
<style lang="less">
.ip-location {
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
</style>
